export const translations = {
  fi: {
    header: {
      logo: 'FunCoolHub',
      nav: ['Etusivu', 'Sisältö', 'Näin se toimii', 'Edut', 'Yhteystiedot'],
      cta: 'LÄHETTÄÄ!',
    },
    hero: {
      title: 'FunCoolHub',
      subtitle:
        'Eksklusiivinen digitaalisen sisällön klubi — katseltavaa ja ladattavaa korkealaatuista interaktiivista sisältöä: mobiilipelejä, sovelluksia, videoita ja muuta.',
      cta: 'LÄHETTÄÄ!',
      poweredBy: 'FUN → 173190',
      imageAlt: 'Henkilö nauttii digitaalisesta viihteestä tabletilla',
    },
    features: {
      title: 'Mitä FunCoolHub tarjoaa',
      subtitle: 'Yksi klubi, monenlaista interaktiivista sisältöä — peleistä videoihin.',
      badge: 'Digitaalinen klubi',
      imageAlt: 'Mobiilipelejä ja sovelluksia puhelimella',
      items: [
        {
          title: 'Mobiilipelit',
          description:
            'Laadukkaita pelejä, joilla viihdyt ja haastat itsesi milloin tahansa.',
        },
        {
          title: 'Sovellukset',
          description:
            'Käytännöllisiä ja viihdyttäviä sovelluksia arkeen ja vapaa-aikaan.',
        },
        {
          title: 'Videot',
          description:
            'Katseltavaa sisältöä, joka sopii nopeaan taukoon tai pidempään sessioon.',
        },
        {
          title: 'Lisää sisältöä',
          description:
            'Interaktiivista digitaalista sisältöä ilman rajoitusta pelkästään yhteen formaattiin.',
        },
      ],
    },
    howItWorks: {
      title: 'Näin se toimii',
      subtitle: 'Kolme selkeää askelta — klikkaa, lähetä SMS ja avaa sisältö.',
      badge: 'Helppo aktivointi',
      imageAlt: 'Puhelin ja digitaalinen sisältö',
      steps: [
        {
          number: '01',
          title: 'Klikkaa',
          description: 'Paina LÄHETTÄÄ! ja avaa valmis tekstiviesti.',
        },
        {
          number: '02',
          title: 'Lähetä FUN',
          description: 'Lähetä viesti FUN numeroon 173190 matkapuhelimestasi.',
        },
        {
          number: '03',
          title: 'Käytä sisältöä',
          description: 'Saat pääsyn klubin digitaaliseen sisältöön aktivoinnin jälkeen.',
        },
      ],
    },
    benefits: {
      title: 'Miksi FunCoolHub?',
      subtitle: 'Selkeä aktivointi, monipuolinen sisältö ja tuki Suomessa.',
      badge: 'Sinulle valmis',
      imageAlt: 'Viihdettä ja pelejä kotona',
      items: [
        {
          title: 'Eksklusiivinen klubi',
          description: 'Pääsy digitaaliseen sisältöön yhdessä paikassa.',
        },
        {
          title: 'Korkealaatuista sisältöä',
          description: 'Pelit, sovellukset, videot ja muu interaktiivinen media.',
        },
        {
          title: 'Nopea aloitus',
          description: 'Yksi SMS-aktivointi: FUN numeroon 173190.',
        },
        {
          title: 'Helppo aktivointi',
          description: 'Aloita yhdellä tekstiviestillä — nopea ja selkeä.',
        },
        {
          title: 'Tuki saatavilla',
          description: 'Ota yhteyttä puhelimitse tai sähköpostitse tarvittaessa.',
        },
        {
          title: 'Käytä omassa tahdissa',
          description: 'Sisältö on saatavilla silloin, kun sinulle sopii.',
        },
      ],
    },
    cta: {
      title: 'Valmis aloittamaan?',
      subtitle: 'Lähetä FUN numeroon 173190 ja aktivoi FunCoolHub.',
      cta: 'LÄHETTÄÄ!',
      features: ['FUN → 173190', 'Digitaalinen sisältö', 'Tuki saatavilla'],
    },
    footer: {
      company: 'FunCoolHub',
      tagline: 'Eksklusiivinen digitaalisen sisällön klubi',
      quickLinks: 'Pikalinkit',
      contact: 'Yhteystiedot',
      address: '160 Robinson Road 14-04, Singapore 068914',
      email: 'heets.fi@silverlines.info',
      phone: '+358 942451583',
      rights: 'Kaikki oikeudet pidätetään.',
      clickzillas:
        'Palveluntarjoaja: Heets Media Pte Ltd, 160 Robinson Road 14-04 Singapore Business Federation Centre, Singapore 068914.',
      privacy: 'AUTA',
      terms: 'KÄYTTÖEHDOT',
      cookies: 'Withdrawal',
      contactLink: 'OTTAA YHTEYTTÄ',
      navHome: 'Etusivu',
      navFeatures: 'Sisältö',
      navHow: 'Näin se toimii',
      navBenefits: 'Edut',
      serviceDescription:
        'FunCoolHub on eksklusiivinen digitaalisen sisällön klubi, jossa pääset katsomaan ja josta pääset lataamaan erilaista korkealaatuista interaktiivista sisältöä mukaan lukien seuraavaa, mutta niihin rajoittumatta: mobiilipelejä, sovelluksia, videoita ja muuta.',
      howItWorks: 'Aktivointi:',
      howItWorksText:
        'Tilataksesi palvelun, klikkaa LÄHETTÄÄ! -painiketta ja lähetä viesti FUN numeroon 173190. Puhelin: +358 942451583, Sähköposti: heets.fi@silverlines.info.',
      subscription:
        'Palveluntarjoaja on Heets Media Pte Ltd 160 Robinson Road 14-04 Singapore Business Federation Centre Singapore 068914.',
    },
  },
  en: {
    header: {
      logo: 'FunCoolHub',
      nav: ['Home', 'Content', 'How it works', 'Benefits', 'Contact'],
      cta: 'SEND!',
    },
    hero: {
      title: 'FunCoolHub',
      subtitle:
        'An exclusive digital content club where you can watch and download high-quality interactive content including mobile games, apps, videos and more.',
      cta: 'SEND!',
      poweredBy: 'FUN → 173190',
      imageAlt: 'Person enjoying digital entertainment on a tablet',
    },
    features: {
      title: 'What FunCoolHub offers',
      subtitle: 'One club, many kinds of interactive content — from games to video.',
      badge: 'Digital club',
      imageAlt: 'Mobile games and apps on a phone',
      items: [
        {
          title: 'Mobile games',
          description: 'Quality games to play and challenge yourself anytime.',
        },
        {
          title: 'Apps',
          description: 'Useful and entertaining apps for everyday life and leisure.',
        },
        {
          title: 'Videos',
          description: 'Watchable content for a quick break or a longer session.',
        },
        {
          title: 'More content',
          description: 'Interactive digital media beyond a single format.',
        },
      ],
    },
    howItWorks: {
      title: 'How it works',
      subtitle: 'Three clear steps — tap, send SMS and open your content.',
      badge: 'Easy activation',
      imageAlt: 'Phone with digital content',
      steps: [
        {
          number: '01',
          title: 'Tap',
          description: 'Press SEND! to open a pre-filled text message.',
        },
        {
          number: '02',
          title: 'Send FUN',
          description: 'Send the message FUN to 173190 from your mobile phone.',
        },
        {
          number: '03',
          title: 'Enjoy content',
          description: 'Access the club’s digital content after activation.',
        },
      ],
    },
    benefits: {
      title: 'Why FunCoolHub?',
      subtitle: 'Clear activation, varied content and support in Finland.',
      badge: 'Ready for you',
      imageAlt: 'Entertainment and games at home',
      items: [
        {
          title: 'Exclusive club',
          description: 'Digital content access in one place.',
        },
        {
          title: 'High-quality content',
          description: 'Games, apps, videos and other interactive media.',
        },
        {
          title: 'Fast start',
          description: 'One SMS activation: FUN to 173190.',
        },
        {
          title: 'Easy activation',
          description: 'Start with one text message — fast and clear.',
        },
        {
          title: 'Support available',
          description: 'Reach us by phone or email when you need help.',
        },
        {
          title: 'At your pace',
          description: 'Use the content whenever it suits you.',
        },
      ],
    },
    cta: {
      title: 'Ready to start?',
      subtitle: 'Send FUN to 173190 and activate FunCoolHub.',
      cta: 'SEND!',
      features: ['FUN → 173190', 'Digital content', 'Support available'],
    },
    footer: {
      company: 'FunCoolHub',
      tagline: 'Exclusive digital content club',
      quickLinks: 'Quick links',
      contact: 'Contact',
      address: '160 Robinson Road 14-04, Singapore 068914',
      email: 'heets.fi@silverlines.info',
      phone: '+358 942451583',
      rights: 'All rights reserved.',
      clickzillas:
        'Service provider: Heets Media Pte Ltd, 160 Robinson Road 14-04 Singapore Business Federation Centre, Singapore 068914.',
      privacy: 'Help',
      terms: 'Terms',
      cookies: 'Withdrawal',
      contactLink: 'Contact',
      navHome: 'Home',
      navFeatures: 'Content',
      navHow: 'How it works',
      navBenefits: 'Benefits',
      serviceDescription:
        'FunCoolHub is an exclusive digital content club where you can watch and download various high-quality interactive content including, but not limited to: mobile games, apps, videos and more.',
      howItWorks: 'Activation:',
      howItWorksText:
        'To order the service, tap SEND! and send the message FUN to 173190. Phone: +358 942451583, Email: heets.fi@silverlines.info.',
      subscription:
        'Service provider is Heets Media Pte Ltd 160 Robinson Road 14-04 Singapore Business Federation Centre Singapore 068914.',
    },
  },
};

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=1400&q=80',
  features: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=1200&q=80',
  howItWorks: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1000&q=80',
  benefits: 'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?auto=format&fit=crop&w=1000&q=80',
};
